var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.298 13.38c.315 0 .602-.102.985-.32l8.203-4.758c.629-.363.943-.698.943-1.23 0-.527-.314-.862-.943-1.231L2.283 1.083C1.9.864 1.613.769 1.298.769.656.769.136 1.254.136 2.074v9.994c0 .82.52 1.313 1.162 1.313z",
    fill: "#FFF",
    fillRule: "nonzero"
  })));
}

export default SvgPlay;